import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { sku } = Dictionary

const SKU = {
    create: async (payload:{}) => {
        return axios.post(BASE_URL + sku.list(), payload);
    },
    list: async () => {
        return axios.get(BASE_URL + sku.list());
    },
    delete: async (id:string) => {
        return axios.delete(BASE_URL + sku.getById(id));
    },
    update: async (id:string, payload:{}) => {
        return axios.put(BASE_URL + sku.getById(id), payload);
    },
    getById: async (id:string) => {
        return axios.get(BASE_URL + sku.getById(id));
    },

}
export default SKU